export default "__VITE_ASSET__DRfxMgMB__"